/**
 * similar to `querySelector()` but throws error if element not found
 * @param selectors query selectors
 * @param [parent=document] root element
 * @returns selected element if exists or throws error otherwise
 */
export function notNullQuerySelector<T extends Element = HTMLElement>(selectors: string, parent: ParentNode = document): T {
    const element = parent.querySelector<T>(selectors);

    if (!element) {
        throw new Error(`can not select '${selectors}'`);
    }

    return element;
}
